import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Translate } from '../../../../language';
import Button from '../../../../utils/components/Button/Button';
import ImgBorder from '../../../../utils/components/ImgBorder/ImgBorder';
import localStorage from '../../../../utils/hooks/useLocalStorage';
import useModal from '../../../../utils/hooks/useModal';
import style from './Join.module.css'

const Join = ({ join, room, src = '', request ,roomsIBelong}) => {
    const history = useHistory()
    const isPrivate = room.privacity === 1;
    const {userInfo } = useSelector(state => state.userInfo)
   
    let id = localStorage().getItem('idProfile')
    if (userInfo.franchiseID) {
        if (userInfo.franchiseID.state ===2 ) {
            if(localStorage().getItem('typeProfile') !="user"){
                id = userInfo.franchiseID._id
            }
            
        }
    }
    const shouldShowModal = isPrivate && !roomsIBelong.filter(_room=>_room._id==room._id).length>0
    console.log();
    const [ref,isShow,setIsShow] = useModal( false)
    useEffect(() => {
      setIsShow(shouldShowModal)
    
      return () => {
        
      }
    }, [room])
    
    return (

        <div>
            {
               isShow &&
                <div className={style.modal}>
                    <div className={style.content_modal}>
                        {'Esta sala es privada, necesitas una invitación del administrador para ingresar'}
                        <div>
                            <Button onClick={() => request()} text='Solicitar invitación' />
                        </div>
                    </div>
                </div>
            }
            <div className={style.content}>

                <ImgBorder width="8vw" borderWidth='6px' color='var(--green-color)' src={room.profilePicture && room.profilePicture.url ? room.profilePicture.url.small : room.profilePicture} />
                <div className={style.title}>{room.name}</div>
                <div className={style.content_button}>

                    {
                        !shouldShowModal ? <>
                       {
                            (roomsIBelong.filter(_room=>{return _room._id==room._id}).length==0) ? (
                                <Button text='Únete' onClick={()=> join() }/>
                            ):(
                                <Button text='Entrar' onClick={()=> history.push(`/Rooms/Room/${room._id}`) }/>
                            )
                       }
                        </>:<Button text='Únete' onClick={()=> setIsShow(true) }/>
                    }
                   
                  
                   
                   {/*  <Button text={'Invita a tus Ecoamigos'} theme='white' /> */}
                </div>
                <div className={style.sub_title}>{!isPrivate ? Translate('public_f', 'es') : Translate('private_f', 'es')}</div>
                <div className={style.sub_title}>{'Reglas de la sala'}</div>
                <div className={style.rules}>
                    {room.rules}
                </div>
            </div>
        </div>
    );
};

export default Join;
